import { render, staticRenderFns } from "./ProductReportsDashboard.vue?vue&type=template&id=15ebe26f&scoped=true"
import script from "./ProductReportsDashboard.vue?vue&type=script&lang=js"
export * from "./ProductReportsDashboard.vue?vue&type=script&lang=js"
import style0 from "./ProductReportsDashboard.vue?vue&type=style&index=0&id=15ebe26f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ebe26f",
  null
  
)

export default component.exports